export const APP_HOST = 'app.clickersphere.com';
